import generateDates from '../../scripts/generateDates';
import { CHANGE_YEAR, CHANGE_MONTH } from '../actions/actionTypes'

const initState = {
  year: new Date().getFullYear(),
  month: new Date().getMonth(),
  dates: generateDates(new Date().getFullYear(), new Date().getMonth()),
}

const dateReducer = (state = initState, action) => {
  switch(action.type) {
    case CHANGE_MONTH:
      return { ...state, month: action.month, dates: generateDates(state.year, action.month) };
    case CHANGE_YEAR:
      return { ...state, year: action.year, dates: generateDates(action.year, state.month) };
    default: return state; 
  }
}

export default dateReducer;